/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AmountsResource } from './';
import {
    AmountsResourceFromJSON,
    AmountsResourceFromJSONTyped,
    AmountsResourceToJSON,
} from './';
import type { AppendixResource } from './';
import {
    AppendixResourceFromJSON,
    AppendixResourceFromJSONTyped,
    AppendixResourceToJSON,
} from './';
import type { Client } from './';
import {
    ClientFromJSON,
    ClientFromJSONTyped,
    ClientToJSON,
} from './';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { FixedPriceQuoteResource } from './';
import {
    FixedPriceQuoteResourceFromJSON,
    FixedPriceQuoteResourceFromJSONTyped,
    FixedPriceQuoteResourceToJSON,
} from './';
import type { Freelancer } from './';
import {
    FreelancerFromJSON,
    FreelancerFromJSONTyped,
    FreelancerToJSON,
} from './';
import type { InvoicingMode } from './';
import {
    InvoicingModeFromJSON,
    InvoicingModeFromJSONTyped,
    InvoicingModeToJSON,
} from './';
import type { QuoteClientTermsResource } from './';
import {
    QuoteClientTermsResourceFromJSON,
    QuoteClientTermsResourceFromJSONTyped,
    QuoteClientTermsResourceToJSON,
} from './';
import type { QuoteOptionsResource } from './';
import {
    QuoteOptionsResourceFromJSON,
    QuoteOptionsResourceFromJSONTyped,
    QuoteOptionsResourceToJSON,
} from './';
import type { QuoteProjectTermsResource } from './';
import {
    QuoteProjectTermsResourceFromJSON,
    QuoteProjectTermsResourceFromJSONTyped,
    QuoteProjectTermsResourceToJSON,
} from './';
import type { QuoteStatus } from './';
import {
    QuoteStatusFromJSON,
    QuoteStatusFromJSONTyped,
    QuoteStatusToJSON,
} from './';
import type { QuoteType } from './';
import {
    QuoteTypeFromJSON,
    QuoteTypeFromJSONTyped,
    QuoteTypeToJSON,
} from './';
import type { TimeAndMaterialsQuoteResource } from './';
import {
    TimeAndMaterialsQuoteResourceFromJSON,
    TimeAndMaterialsQuoteResourceFromJSONTyped,
    TimeAndMaterialsQuoteResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface QuoteResource
 */
export interface QuoteResource {
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    id: string;
    /**
     * 
     * @type {QuoteType}
     * @memberof QuoteResource
     */
    type: QuoteType;
    /**
     * 
     * @type {Client}
     * @memberof QuoteResource
     */
    client: Client;
    /**
     * 
     * @type {Freelancer}
     * @memberof QuoteResource
     */
    freelancer: Freelancer;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    correlationId: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    conversationId: string;
    /**
     * 
     * @type {QuoteStatus}
     * @memberof QuoteResource
     */
    status: QuoteStatus;
    /**
     * 
     * @type {Currency}
     * @memberof QuoteResource
     */
    currencyCode: Currency;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    title: string;
    /**
     * 
     * @type {InvoicingMode}
     * @memberof QuoteResource
     */
    invoicingMode: InvoicingMode;
    /**
     * 
     * @type {QuoteProjectTermsResource}
     * @memberof QuoteResource
     */
    projectTerms?: QuoteProjectTermsResource;
    /**
     * 
     * @type {QuoteClientTermsResource}
     * @memberof QuoteResource
     */
    clientTerms?: QuoteClientTermsResource;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    freelancerTerms?: string;
    /**
     * 
     * @type {AppendixResource}
     * @memberof QuoteResource
     */
    appendix?: AppendixResource;
    /**
     * 
     * @type {Date}
     * @memberof QuoteResource
     */
    submissionDate: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuoteResource
     */
    cancellationDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof QuoteResource
     */
    expirationDate: Date;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    pdfUrl: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    purchaseOrder?: string;
    /**
     * 
     * @type {string}
     * @memberof QuoteResource
     */
    referenceNumber?: string;
    /**
     * 
     * @type {AmountsResource}
     * @memberof QuoteResource
     */
    amounts: AmountsResource;
    /**
     * 
     * @type {QuoteOptionsResource}
     * @memberof QuoteResource
     */
    options: QuoteOptionsResource;
}

/**
 * Check if a given object implements the QuoteResource interface.
 */
export function instanceOfQuoteResource(value: object): value is QuoteResource {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('client' in value) || value['client'] === undefined) return false;
    if (!('freelancer' in value) || value['freelancer'] === undefined) return false;
    if (!('correlationId' in value) || value['correlationId'] === undefined) return false;
    if (!('conversationId' in value) || value['conversationId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('currencyCode' in value) || value['currencyCode'] === undefined) return false;
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('invoicingMode' in value) || value['invoicingMode'] === undefined) return false;
    if (!('submissionDate' in value) || value['submissionDate'] === undefined) return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined) return false;
    if (!('pdfUrl' in value) || value['pdfUrl'] === undefined) return false;
    if (!('amounts' in value) || value['amounts'] === undefined) return false;
    if (!('options' in value) || value['options'] === undefined) return false;
    return true;
}

export function QuoteResourceFromJSON(json: any): QuoteResource {
    return QuoteResourceFromJSONTyped(json, false);
}

export function QuoteResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuoteResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['type'] === 'FIXED_PRICE') {
            return FixedPriceQuoteResourceFromJSONTyped(json, true);
        }
        if (json['type'] === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteResourceFromJSONTyped(json, true);
        }
    }
    return {
        
        'id': json['id'],
        'type': QuoteTypeFromJSON(json['type']),
        'client': ClientFromJSON(json['client']),
        'freelancer': FreelancerFromJSON(json['freelancer']),
        'correlationId': json['correlationId'],
        'conversationId': json['conversationId'],
        'status': QuoteStatusFromJSON(json['status']),
        'currencyCode': CurrencyFromJSON(json['currencyCode']),
        'title': json['title'],
        'invoicingMode': InvoicingModeFromJSON(json['invoicingMode']),
        'projectTerms': json['projectTerms'] == null ? undefined : QuoteProjectTermsResourceFromJSON(json['projectTerms']),
        'clientTerms': json['clientTerms'] == null ? undefined : QuoteClientTermsResourceFromJSON(json['clientTerms']),
        'freelancerTerms': json['freelancerTerms'] == null ? undefined : json['freelancerTerms'],
        'appendix': json['appendix'] == null ? undefined : AppendixResourceFromJSON(json['appendix']),
        'submissionDate': (new Date(json['submissionDate'])),
        'cancellationDate': json['cancellationDate'] == null ? undefined : (new Date(json['cancellationDate'])),
        'expirationDate': (new Date(json['expirationDate'])),
        'pdfUrl': json['pdfUrl'],
        'purchaseOrder': json['purchaseOrder'] == null ? undefined : json['purchaseOrder'],
        'referenceNumber': json['referenceNumber'] == null ? undefined : json['referenceNumber'],
        'amounts': AmountsResourceFromJSON(json['amounts']),
        'options': QuoteOptionsResourceFromJSON(json['options']),
    };
}

export function QuoteResourceToJSON(value?: QuoteResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
        if (value.type === 'FIXED_PRICE') {
            return FixedPriceQuoteResourceToJSON(value as FixedPriceQuoteResource);
        }
        if (value.type === 'TIME_AND_MATERIALS') {
            return TimeAndMaterialsQuoteResourceToJSON(value as TimeAndMaterialsQuoteResource);
        }
    }
    return {
        
        'id': value['id'],
        'type': QuoteTypeToJSON(value['type']),
        'client': ClientToJSON(value['client']),
        'freelancer': FreelancerToJSON(value['freelancer']),
        'correlationId': value['correlationId'],
        'conversationId': value['conversationId'],
        'status': QuoteStatusToJSON(value['status']),
        'currencyCode': CurrencyToJSON(value['currencyCode']),
        'title': value['title'],
        'invoicingMode': InvoicingModeToJSON(value['invoicingMode']),
        'projectTerms': QuoteProjectTermsResourceToJSON(value['projectTerms']),
        'clientTerms': QuoteClientTermsResourceToJSON(value['clientTerms']),
        'freelancerTerms': value['freelancerTerms'],
        'appendix': AppendixResourceToJSON(value['appendix']),
        'submissionDate': ((value['submissionDate']).toISOString()),
        'cancellationDate': value['cancellationDate'] == null ? undefined : ((value['cancellationDate']).toISOString()),
        'expirationDate': ((value['expirationDate']).toISOString()),
        'pdfUrl': value['pdfUrl'],
        'purchaseOrder': value['purchaseOrder'],
        'referenceNumber': value['referenceNumber'],
        'amounts': AmountsResourceToJSON(value['amounts']),
        'options': QuoteOptionsResourceToJSON(value['options']),
    };
}

